import _ from 'lodash';
import { BaseController } from '../../common/base/controller';
import { OldPortfolioOptions } from './oldPortfolio.constant';
import { OldPortfolioModel } from './oldPortfolio.model';

export class OldPortfolioController extends BaseController {
  oldPortfolioForm = {};

  constructor($scope, controllerService, securitiesService, configService) {
    'ngInject';
    super({
      $scope,
      controllerService,
      securitiesService,
      configService,
    });
  }

  get guidedTourIsActive() {
    return this.appCache.get('guidedTourIsActive');
  }

  get iconPath() {
    return this.configService.getFeature(this.Features.infoIconPath);
  }

  get FeatureUSWithholdingTaxCheck() {
    return this.configService.isFeatureActive(
      this.Features.USWithholdingTaxCheck,
    );
  }

  get FeatureForeignResidenceCheck() {
    return this.configService.isFeatureActive(
      this.Features.foreignResidenceCheck,
    );
  }

  get proceedsOnClearingAccountEnabled() {
    return this.configService.isFeatureActive(
      this.Features.proceedsOnClearingAccount,
    );
  }

  $onInit() {
    // Set cached or initial models
    const oldPortfolioCached = this.appCache.get('oldPortfolio') || {};
    this.oldPortfolio = new OldPortfolioModel(oldPortfolioCached);

    this.transferAllSecurities =
      this.appCache.get('transferAllSecurities') || false;

    // dont precheck when cached version is available and user goes backwards
    // otherwise all checks get corrupted
    if (_.isEmpty(oldPortfolioCached)) {
      this.oldPortfolio.precheckAllOptions(this.transferAllSecurities);
    }

    // Setup options
    this.oldPortfolioOptions = OldPortfolioOptions.map((option) => {
      return _.merge(option, {
        type: 'checkbox',
        iconPath: this.iconPath,
        isDisabled: this.isToggleOptionDisabled(option),
      });
    });

    this.disposeSecuritiesAccountOption = {
      type: 'checkbox',
      infoTextKey: 'app.oldPortfolioState.disposeSecuritiesAccount.info',
      label: 'app.oldPortfolioState.disposeSecuritiesAccount',
      name: 'app.oldPortfolioState.disposeSecuritiesAccount',
      model: 'disposeSecuritiesAccount',
      checked: this.oldPortfolio.disposeSecuritiesAccount,
    };

    this.setModelBindings();
  }

  isToggleOptionDisabled(option) {
    return option.model == 'transferCapitalLoss' && !this.transferAllSecurities;
  }

  setModelBindings() {
    this.$scope.$watch(
      'vm.oldPortfolio.disposeSecuritiesAccount',
      (newValue) => {
        if (!this.watchModelBindings) return;
        this.oldPortfolio.precheckAllOptions(newValue);
      },
    );

    // Prevent initial watch trigger
    this.$timeout(() => (this.watchModelBindings = true));
  }

  prev() {
    this.updateCache();
    this.prevState();
  }

  next() {
    // in this case the switch can not be performed
    if (this.FeatureUSWithholdingTaxCheck && !this.USWithholdingTax) {
      this.appCache.set('USWithholdingTax', true);
      return this.go('app.switchNotAllowed');
    }

    // in this case the switch can not be performed
    if (this.FeatureForeignResidenceCheck && !this.foreignResidence) {
      this.appCache.set('foreignResidence', true);
      return this.go('app.switchNotAllowed');
    }

    // TODO: Warning! Backend does not ignore bank account properties even though sell fragments is not checked!
    if (!this.oldPortfolio.sellFragments) {
      this.resetBankProperties();
    }

    this.updateCache();

    this.oldPortfolioForm.$submitted = true;
    if (!this.oldPortfolioForm.$valid) {
      return;
    }

    this.nextState();
  }

  updateCache() {
    this.appCache.set('oldPortfolio', this.oldPortfolio);

    // Set old bank only if it is defined
    if (this.oldBank) {
      this.appCache.set('oldBank', this.oldBank);
    }
  }

  resetBankProperties() {
    this.oldPortfolio.fragmentsProceedsDestinationIban = null;
    this.oldPortfolio.fragmentsProceedsDestinationBic = null;
    this.oldPortfolio.fragmentsProceedsDestinationBankName = null;
    this.oldPortfolio.fragmentsProceedsDestinationAccountOwner = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/oldPortfolio/oldPortfolio.controller.js